import {PageHeader} from "../components/PageHeader";
import {LegalDocument} from "../components/LegalDocument";
import {legalPages} from "../i18n";
import {legal} from "../legal";

// The list is src/i18n/en/legal/cookies.md. Keep it in step with what the site and API actually store:
// auth/tokenStore.ts, theme/ThemeContext.tsx, components/usePersistentState.ts and components/CookieNotice.tsx.
export function CookiesPage() {
    return (
        <div className="legal-text">
            <PageHeader title={legalPages.cookies.title} description={legalPages.cookies.description}/>
            <LegalDocument markdown={legalPages.cookies.document} values={legal}/>
        </div>
    );
}
